'use client';

import { PaymentAccountForm } from '@/features/auth';
import { usePaymentStore } from '../../store';

export const PaymentStep1 = () => {
	const { values, errors, updateValues, goNextStep } = usePaymentStore();
	return (
		<PaymentAccountForm
			values={values}
			errors={errors}
			updateValues={updateValues}
			goNextStep={goNextStep}
		/>
	);
};
